export default __webpack_public_path__ + "static/media/Foto-01.90c8f14d.png";